import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartData: [],
};

export const addToCartSlice = createSlice({
  name: "addToCart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      state.cartData.push(action.payload);
    },
    deleteCart: (state, action) => {
      state.cartData = state.cartData.filter(
        (cart) => cart._id !== action.payload
      );
    },
  },
});

export const { addToCart, deleteCart } = addToCartSlice.actions;
export default addToCartSlice.reducer;
